import { FormikHelpers } from "formik";

import { toast } from "react-toastify";

import { AddAccomodationInitialValues } from "./FormikValidation";
import { api } from "../../../../../../Api/Api";
import { setValidationErrors } from "../../../../../../Utils/helpers/helpers";

type AddInitialValues = {
  name: string;
  district: string;
};

export const StaffSubmitHandler = (
  values: AddInitialValues,
  actions: FormikHelpers<AddInitialValues>,
  setIsOpen: Function,
  refetch: Function,
  editMode: boolean,
  id: string | number
) => {
  // Add
  if (editMode) {
    api
      .patch(`/office-accomodation/${id}`, values, true)
      .then(async function ([success, response]: any) {
        toast.success("Accomodation Details Updated ",{toastId:"9190"});
        setIsOpen(false);
        refetch();
      })
      .catch((err) => {
        actions?.setSubmitting(false);
        if (err?.response?.data?.errors) {
          setValidationErrors(err?.response?.data?.errors, actions);
        } else {
          toast.error("Unexpected Error Occurred",{toastId:"9191"});
        }
      });
  }
  // Edit
  else {
    api
      .post(
        "/office-accomodation",
        {
          name: values?.name,
          district_id: values?.district
        },
        true
      )
      .then(async function ([success, response]: any) {
        toast.success("Accomodation Added ",{toastId:"9192"});
        setIsOpen(false);
        refetch();
      })
      .catch((err) => {
        actions?.setSubmitting(false);
        if (err?.response?.data?.errors) {
          setValidationErrors(err?.response?.data?.errors, actions);
        } else {
          toast.error("Unexpected Error Occurred",{toastId:"9193"});
        }
      });
  }
};

// extract Departmentdata for table
export const extractStaffData = (data: any) => {
  const res = data?.data?.map((item: any) => {
    return {
      id: item?.id,
      name: item?.name,
      district: item?.district?.name,
    };
  });
  return res;
};

// initializing add Department form - Edit / add
export const addModalInitialValuesHandler = (
  modalEditData: any,
  setAddModalInitialValues: Function,
  setEditMode: Function
) => {
  if (modalEditData?.length !== 0) {
    setEditMode(true);
    setAddModalInitialValues({
      id: modalEditData?.[0]?.id,
      name: modalEditData?.[0]?.name,
      district: modalEditData?.[0]?.district,
    });
  } else {
    setEditMode(false);
    setAddModalInitialValues(AddAccomodationInitialValues);
  }
};

// Department table edit onclick trigger
export const onEditClickHandler = (
  selectedId: any,
  setModalEditData: Function,
  setIsOpen: Function,
  doctorData: any
) => {
  setModalEditData([]);
  setModalEditData(
    doctorData?.data?.filter((itm: any) => itm?.id === selectedId)
  );

  setIsOpen(true);
};

// add Department open / close
export const modalHandler = (
  setModalEditData: Function,
  setIsOpen: Function
) => {
  setModalEditData([]);
  setIsOpen(true);
};

// Department delete
export const deleteClickHandler = (
  selectedId: string | number,
  refetch: Function
) => {
  api
    .delete(`/office-accomodation/${selectedId}`, {}, true)
    .then(async function ([success, response]: any) {
      refetch();
      toast.success("Deleted",{toastId:"9194"});
    })
    .catch((err) => {
      toast.error("Unexpected Error Occurred",{toastId:"9195"});
    });
};

export const setCurrentPageStaff = (navigate: Function, pageNo: any, pathname: any) => {
  if (pathname?.startsWith("/member")) {
    navigate(`/member/accomodation/${pageNo}`)
  }
  if (pathname?.startsWith("/admin")) {
    navigate(`/admin/accomodation/${pageNo}`)
  }
};


